import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate ,useLocation} from 'react-router-dom';
import DataTable from '../../../Layout/Table//TableLayoutOpp';
import { FaEdit, FaTrash, FaEye, FaComment, FaUserPlus, FaDownload, FaCopy } from 'react-icons/fa';
import { Button, Row, Col, Modal } from 'react-bootstrap';
import Navbar from '../../../Shared/ManagerNavbar/Navbar';
import { baseURL, webhookUrl } from '../../../Apiservices/Api';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { useQuery } from '@tanstack/react-query';
import { useQueryClient } from '@tanstack/react-query';
import Loader from '../../../Loader/Loader';

import './Alllead.css'

const AdminViewLeads = () => {
    const queryClient = useQueryClient();

    const {
  data = [],
  isLoading,
  isError,
  error,
} = useQuery({
  queryKey: ['leads'],  // cache key
  refetchInterval: 3000, // 🔥 refetch every 3 seconds
  queryFn: async () => {
    const response = await fetch(`${baseURL}/api/addleads/statuslead`);
    const json = await response.json();

    const list = Array.isArray(json.data)
      ? json.data
      : Array.isArray(json)
      ? json
      : [];

    return list; // no filtering here
  },
  keepPreviousData: true,
});


  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [message, setMessage] = useState(null);
  // const [data, setData] = useState([]);
    const location = useLocation();
  const [pageIndex, setPageIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  // Function to export data to Excel
  const downloadExcel = () => {
    if (data.length === 0) {
      alert("No data available to export.");
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(dataBlob, "LeadsData.xlsx");
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setMessage("Copied to clipboard!");
      setTimeout(() => setMessage(""), 1000);  // Optional: Show a message
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const pageFromUrl = parseInt(params.get("page"));

  if (!isNaN(pageFromUrl)) {
    setPageIndex(pageFromUrl - 1); 
  }
}, [location.search]);

useEffect(() => {
      const params = new URLSearchParams(location.search);
      const pageFromUrl = parseInt(params.get("page"));
      const pageSizeFromUrl = parseInt(params.get("pageSize"));
      
      if (!isNaN(pageFromUrl)) {
        setPageIndex(pageFromUrl - 1);
      }
      
    }, [location.search]);


  const handleViewLeads = (lead,currentPage) => {
                 const params = new URLSearchParams(location.search);
  const pageSize = params.get('pageSize') || '20';

    navigate(`/m-viewallleads/${lead.leadid}?page=${currentPage + 1}&pageSize=${pageSize}`, {
      state: { leadid: lead.leadid },
    });
  };


  const dropdownOptions = {
    primary: ["New", "No Response", "Duplicate", "False Lead", "Lost"],
    secondary: {
      New: ["Yet to Contact", "Not picking up call", "Asked to call later"],
      "No Response": [],
      Duplicate: [],
      "False Lead": [],
      Lost: ["Plan Cancelled", "Plan Delayed", "Already Booked", "Others"],
    },
  };


  const [managers, setManagers] = useState([]); // State to store fetched managers
 const [managersLoading, setManagersLoading] = useState(true);
const [managersError, setManagersError] = useState(null);



  useEffect(() => {
    const fetchManagers = async () => {
       setManagersLoading(true); // Start loading
      try {
        const response = await fetch(`${baseURL}/managers`);
        if (!response.ok) {
          throw new Error("Failed to fetch managers");
        }
        const result = await response.json(); // Parse JSON directly from response
        console.log("Fetched data:", result.data); // Log fetched data
        console.log(JSON.stringify(result.data, null, 2)); // Log fetched data in pretty format
        setManagers(result.data); // Update the managers state
        setManagersLoading(false); // Set loading to false after successful fetch
      } catch (err) {
        console.error("Error fetching managers:", err.message); // Log the error
        setManagersError(err.message); // Update error state
        // setLoading(false); // Stop loading on error
      }
      finally {
      setManagersLoading(false); // Stop loading
    }

    };

    fetchManagers();
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "LeadID",
        accessor: 'leadid',
      },

      {
        Header: "lead Name",
        accessor: "name",
          Cell: ({ row }) => {
          const currentPage = pageIndex; 
              const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';
          return (
          <div>
            <div
              style={{ cursor: "pointer", color: "blue", textDecoration: "underline" }}
              onClick={() => handleViewLeads(row.original,currentPage, pageSize)} // Navigate on click
            >
              {row.original.name}
            </div>
          </div>
        )
      }
    },
      {
        Header: "Mobile",
        accessor: "phone_number",
        Cell: ({ row }) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <a
              href={`https://wa.me/${row.original.phone_number}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "blue", cursor: "pointer" }}
              title="Chat on WhatsApp"
            >
              {row.original.phone_number}
            </a>
            <FaCopy
              style={{ marginLeft: "8px", cursor: "pointer", color: "#ff9966" }}
              onClick={() => copyToClipboard(row.original.phone_number)}
              title="Copy Phone Number"
            />
          </div>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        Cell: ({ row }) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between", // Push copy button to the right
              width: "100%",
              maxWidth: "200px", // Adjust width as needed
            }}
          >
            <div
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "150px",
              }}
              title={row.original.email} // Show full email on hover
            >
              {row.original.email}
            </div>
            <FaCopy
              style={{ cursor: "pointer", color: "#ff9966" }}
              onClick={() => copyToClipboard(row.original.email)}
              title="Copy Email"
            />
          </div>
        ),
      },
  {
        Header: "Destination",
        accessor: "destination",
        Cell: ({ row }) => (
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "150px",
            }}
            title={row.original.destination}
          >
            {row.original.destination}
          </div>
        ),
      },

      {
        Header: 'Source',
        accessor: 'sources',
      },


      {
        Header: "Actions",
        Cell: ({ row }) => {
              const currentPage = pageIndex; // Capture current page index
                                const params = new URLSearchParams(location.search);
    const pageSize = params.get('pageSize') || '20';

    return (

          <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
            <FaEye
              style={{ color: "#ff9966", cursor: "pointer" }}
              onClick={() => handleViewLeads(row.original,currentPage,pageSize)}
            />
          </div>
    )
        
        },
      },

    ],
    [dropdownOptions,pageIndex, managers, location]
  );

  return (
    <div className="admin-ViewLeadcontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`admin-ViewLead ${collapsed ? "collapsed" : ""}`}>
        <div className="admin-ViewLead-container mb-5">
          <div className="admin-ViewLead-table-container">
            <Row className="mb-3">
              <Col className="d-flex justify-content-between align-items-center">
                <h3>Lead Details</h3>
                {message && <div className="alert alert-info">{message}</div>}
                {/* <Button onClick={handleAddLead}>Add Leads</Button> */}
                {/* <button className="btn btn-success" onClick={downloadExcel}>
                  <FaDownload /> Download Excel</button> */}
              </Col>
            </Row>
            <Row>
            </Row>

             {loading ? (
              <Loader />
            ) : data.length === 0 ? (
                        <div className="text-center p-5">
                          <p>No data available</p>
                        </div>
                      ) : (
           
             <DataTable 
                            columns={columns} 
                           data={data}
                            pageIndex={pageIndex}
                            setPageIndex={setPageIndex}
                          />
            
          )}
            
          </div>

        </div>
      </div>
    </div>
  );
};

export default AdminViewLeads;
